// extracted by mini-css-extract-plugin
module.exports = {"toysCount":"toysCount_toysCount__ChudJ"};